// if (!customElements.get('product-modal')) {
//   customElements.define(
//     'product-modal',
//     class ProductModal extends ModalDialog {
//       constructor() {
//         super();
//       }

//       hide() {
//         super.hide();
//       }

//       show(opener) {
//         super.show(opener);
//         this.showActiveMedia();
//       }

//       showActiveMedia() {
//         this.querySelectorAll(
//           `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
//         ).forEach((element) => {
//           element.classList.remove('active');
//         });
//         const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
//         const activeMediaTemplate = activeMedia.querySelector('template');
//         const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
//         activeMedia.classList.add('active');
//         activeMedia.scrollIntoView();

//         const container = this.querySelector('[role="document"]');
//         container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

//         if (
//           activeMedia.nodeName == 'DEFERRED-MEDIA' &&
//           activeMediaContent &&
//           activeMediaContent.querySelector('.js-youtube')
//         )
//           activeMedia.loadContent();
//       }
//     }
//   );
// }
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
  this.querySelectorAll(
    `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
  ).forEach((element) => {
    element.classList.remove('active');
  });

  const activeMedia = this.querySelector(
    `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
  );

  if (!activeMedia) return;

  activeMedia.classList.add('active');
  activeMedia.scrollIntoView();

  const container = this.querySelector('[role="document"]');
  container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;

  // Load deferred media (Shopify video, YouTube, Vimeo)
  if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
    activeMedia.loadContent();

    // Wait until the video is created, then play it
    const checkVideo = setInterval(() => {
      const video = activeMedia.querySelector('video');

      if (video) {
        clearInterval(checkVideo);

        video.currentTime = 0;
        video.muted = false;
        video.play().catch(() => {});
      }
    }, 50);
  }
}
    }
  );
}
